import { URLS } from '../constants'
import { dispatchFetchGet, dispatchFetchPost, dispatchFetchPut } from './ActionsUtil'
import {
  POST_GENERATE_CHARGE_BEGIN, POST_GENERATE_CHARGE_SUCCESS, POST_GENERATE_CHARGE_FAILURE, CLEAR_CHARGE_INFO, INSERT_INTO_CHARGE_CREATION, GET_ISS_TAX_BEGIN, GET_ISS_TAX_SUCCESS, GET_ISS_TAX_FAILURE, PUT_ISS_TAX_BEGIN, PUT_ISS_TAX_SUCCESS, PUT_ISS_TAX_FAILURE,
} from '../constants/ActionTypes'


const acGeneratePaymentBegin = () => ({ type: POST_GENERATE_CHARGE_BEGIN, })
const acGeneratePaymentSuccess = payload => ({
  type: POST_GENERATE_CHARGE_SUCCESS, payload: { response: payload }
})
const acGeneratePaymentFailure = err => ({
  type: POST_GENERATE_CHARGE_FAILURE, payload: err
})

export const acGeneratePayment = (customerId, amount, paymentMethod) => {
  return dispatchFetchPost(
    `${URLS.FINANCIAL.PAYMENT}`,
    {
      customerId, amount, paymentMethod
    },
    acGeneratePaymentBegin,
    acGeneratePaymentSuccess,
    acGeneratePaymentFailure,
  )
}

export const acGenerateSubscription = (customerId, amount, paymentMethod, maxPayments, planId) => {
  return dispatchFetchPost(
    `${URLS.FINANCIAL.SUBSCRIPTION}`,
    {
      customerId, amount, paymentMethod, maxPayments, planId
    },
    acGeneratePaymentBegin,
    acGeneratePaymentSuccess,
    acGeneratePaymentFailure,
  )
}

const acGetIssTaxBegin = () => ({ type: GET_ISS_TAX_BEGIN, })
const acGetIssTaxSuccess = payload => ({
  type: GET_ISS_TAX_SUCCESS, payload: { response: payload }
})
const acGetIssTaxFailure = err => ({
  type: GET_ISS_TAX_FAILURE, payload: err
})

export const acGetIssTax = () => {
  return dispatchFetchGet(
    `${URLS.FINANCIAL.CONFIG.ISS_TAX}`,
    acGetIssTaxBegin,
    acGetIssTaxSuccess,
    acGetIssTaxFailure,
  )
}

const acPutIssTaxBegin = () => ({ type: PUT_ISS_TAX_BEGIN, })
const acPutIssTaxSuccess = payload => ({
  type: PUT_ISS_TAX_SUCCESS, payload: { response: payload }
})
const acPutIssTaxFailure = err => ({
  type: PUT_ISS_TAX_FAILURE, payload: err
})

export const acPutIssTax = (issTax) => {
  return dispatchFetchPut(
    `${URLS.FINANCIAL.CONFIG.ISS_TAX}`,
    {
      issTax
    },
    acPutIssTaxBegin,
    acPutIssTaxSuccess,
    acPutIssTaxFailure,
  )
}

export const acInsertIntoChargeCreation = payload => ({ type: INSERT_INTO_CHARGE_CREATION, payload: payload})
export const acClearChargeInfo = () => ({ type: CLEAR_CHARGE_INFO })